import { Dispatch, SetStateAction } from 'react';
import { RowsGroups, RowsGroupsAction } from 'common/reducers/rowsGroups/types';
import { FinancialStatementPeriod } from 'common/types/financials';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

interface IncomeStatementOrBalanceSheetData {
  cells: ICell[];
  config: any[];
  customTitles: any[];
  setColumns: Dispatch<SetStateAction<FinancialStatementPeriod[]>>;
  spreadsheet: SpreadsheetConfig | null;
  tableTerms: {
    columnName: string;
    pluralColumnName: string;
    tableName: string;
    tableSlug: string;
  };
  updateCells: (newCells: any) => Promise<void>;
  visibleColumns: FinancialStatementPeriod[];
}

const setRowGroupsOnSheet = ({
  incomeStatementOrBalanceSheetData,
  rowGroups,
  setRowGroups
}: {
  incomeStatementOrBalanceSheetData: IncomeStatementOrBalanceSheetData;
  rowGroups: RowsGroups;
  setRowGroups: Dispatch<RowsGroupsAction>;
}) => ({
  ...incomeStatementOrBalanceSheetData,
  rowGroups,
  setRowGroups,
});

export default setRowGroupsOnSheet;
